export default [
    {
        key: 'AutomaticDistributeModal',
        getComponent: function () { return import('./AutomaticDistributeModal'); },
        width: 700,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'DimensionSelectModal',
        getComponent: function () { return import('./DimensionSelectModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'BatchAutoDistributeModal',
        getComponent: function () { return import('./BatchAutoDistributeModal'); },
        width: 400,
        title: '',
        maskClosable: false,
        timeout: 500,
    },
    {
        key: 'BatchCompleteModal',
        getComponent: function () { return import('./BatchCompleteModal'); },
        width: 600,
        title: '',
        maskClosable: false,
        timeout: 500,
    },
];
